import EditorImg from 'lowcode/components/EditorImg';
import styles from './index.module.scss';
import { useEffect, useRef, useState } from 'react';

export default function BannerA() {
    const [isEnterA, setisEnterA] = useState(false);
    const isEnterRefA = useRef(false);

    useEffect(() => {
        const elem = document.querySelector(`#BannerA-id`);
        if (elem) {
            window.addEventListener('scroll', () => {
                const clientH = document.documentElement.clientHeight;
                const enterAH =  Math.max(clientH - 300, clientH * 0.8);
                const { top } = elem.getBoundingClientRect();
                const hIsEnterA = top < enterAH; //距离已进入

                if (!isEnterRefA.current && hIsEnterA) {
                    isEnterRefA.current = true;
                    setisEnterA(true);
                } else if (isEnterRefA.current && !hIsEnterA) {
                    isEnterRefA.current = false;
                    setisEnterA(false);
                }
            });
        }
    }, []);

    return (
        <div className={`${styles.comp}`} id="BannerA-id">
            <div className={`img-box`}>
                <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799600110/aab01.jpg" h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799618489/aab02.jpg" />
            </div>
            <div className={`msg-box editor-ani-trigger${isEnterA ? ' isEnter' : ''}`}>
                <div className='msg-box-in'>
                    <h1 className="msg-title editor-ani-title-1">EcoFlow DELTA Pro Ultra + Smart Home Panel 2</h1>
                    <p className="msg-desc editor-ani-title-2">Your smart energy solutions for everyday savings with Time of Use.</p>
                </div>
            </div>
        </div>
    );
}
